export default __webpack_public_path__ + "static/media/Subtract.e3f2e6dd.svg";